module.exports = __webpack_public_path__ + "media/images/views/talent/talent-lp-sp-a585f90e89cf3f175e30c0263f785dc1.jpg";